<nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
    <span class="cat__core__title d-block mt-2 mb-2">
        <strong>Templates</strong>
    </span>
</nav>

<div class="templates">
    <div class="text-center" *ngIf="!templateOpen">
        <h3 class="text-black px-3">Copy a message to email</h3>
        <p class="px-3">Emails from personal email accounts have proven to be the best source of donations</p>
        <div class="templates-wrapper">
            <div class="row justify-content-center">
                <div class="col-auto template-item"
                     *ngFor="let template of templates"
                     (click)="openTemplate(template)">
                    <div class="template-inner">
                        <img [src]="templateIcons[template.sysTemplateTypeName]"/>
                        <p class="template-name">{{template.sysTemplateTypeDescription}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-templates *ngIf="templateOpen" [template]="template" [(templateOpen)]="templateOpen"></app-templates>
</div>